import { z } from 'zod'

import { TimeObjectSchema } from '@/modules/creator-settings/types.ts'
import {
  FollowUpRequestBodySchema,
  FollowUpSchema,
} from '@/modules/message/components/follow-ups/types.ts'
import {
  MessageSchema,
  MessageSequenceSchema,
} from '@/modules/message/service/message-service.tsx'

export const ExpiringFansMessageSchema = z.object({
  id: z.number(),
  sequence: MessageSequenceSchema,
  timeframeEnd: z.string(),
  timeframeStart: z.string(),
  includedFanLists: z.array(z.string()),
  excludedFanLists: z.array(z.string()),
  statistics: z.object({
    totalPPVBought: z.number(),
    totalReads: z.number(),
    totalSent: z.number(),
    totalResponses: z.number(),
  }),
  followUpEnabled: z.boolean(),
  followUpDto: FollowUpSchema.optional(),
})

export type ExpiringFansMessage = z.infer<typeof ExpiringFansMessageSchema>

export const ExpiringFansMessageFormSchema = z.object({
  id: z.number().optional(),
  messages: MessageSchema.array(),
  timeframeEnd: TimeObjectSchema.optional().nullable(),
  timeframeStart: TimeObjectSchema.optional().nullable(),
  includedFanLists: z.array(z.string()),
  excludedFanLists: z.array(z.string()),
  followUpEnabled: z.boolean(),
  followUpDto: FollowUpRequestBodySchema.nullable().optional(),
})

export type ExpiringFansMessageRequestBody = z.infer<
  typeof ExpiringFansMessageFormSchema
>

export type ExpiringFansMessageUI = z.infer<typeof MessageSchema> & {
  additionalInfo: Omit<ExpiringFansMessage, 'message'>
}
